import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getUser } from '../utils/UserDetails';


function AuthRoute({ component: Component, ...rest }) {

  let redirectLink = '/';

  if(getUser()) {
    redirectLink = '/users';
  }
  
  
  return (
    <Route {...rest}
      render={
        props =>
        (
          getUser() ?  <Redirect to={
            {
              pathname: redirectLink
            }
          }
          />
         :  <Component {...props} />
        )
      }
    />
  )
}

export default AuthRoute;